<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="col-12 bg-primary py-3  text-center" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>پشتیبانی   </template>
                </m-h5></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-single-page-1 v-bind='{...{"contentLink":"contact-us"},...{}}' :style='""' class="col-12" ></m-single-page-1></template>
                </m-div></template>
                </m-div><m-chat-widget-1 v-bind='{...{"enableAnimation":false,"defaultCategory":null},...{}}' :style='"margin-bottom:130PX;"' class="" >
                <template #default>   </template>
                </m-chat-widget-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mSinglePage1 from '@moeinmdn/miw-alpha-components/src/package/Page/Single/SinglePage1'; import mChatWidget1 from '@moeinmdn/miw-alpha-components/src/package/Chat/Widget/ChatWidget1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH5,mSinglePage1,mChatWidget1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
